export default {
	addListener: () => null,
	startGrid: () => null,
};
